import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-field-workflow-id',
    templateUrl: './editor-booking-item-setting-field-workflow-id.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingFieldWorkflowIdComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  workflowNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.workflowNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(workflowNames => this.workflowNames = workflowNames);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
